import React from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import colors from "theme/config/colors";
import { above } from "core-web/utils/mediaqueries";
import { textStyleToString } from "theme/config/textStyles";

const StyledOrderedList = styled("ol")`
    background-color: ${colors.neutral_50};
    border-radius: 12px;
    color: ${colors.primaryTextDark};
    padding: 24px 16px 24px 33px;

    ${above.tabletLg} {
        padding: 24px 24px 24px 40px;
    }

    li {
        ${textStyleToString("Myriad Pro/18-140")};

        ${above.tabletLg} {
            ${textStyleToString("Myriad Pro/16-140")};
        }

        &:not(:last-of-type) {
            margin-bottom: 16px;
        }
    }
`;

const OrderedList = ({ children }) => <StyledOrderedList>{children}</StyledOrderedList>;

OrderedList.propTypes = {
    children: PropTypes.node.isRequired,
};

export default OrderedList;
